import React from "react";
import { dialog, Button } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import ManualTSheetsPresenter from "./ManualTSheetsPresenter";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import { Spin } from "antd";
import Progress from "../../../components/Progress";
import { FloatingForm } from "../../../components/common/Converter";
import CardView from "../../../components/common/CardView";

class ManualTSheetsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.presenter = new ManualTSheetsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      employee: {},
      employees: [],
      enrichedData: {},
      isSubmitted: false,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "employees";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleChange(value) {
    this.setState({
      employee: value,
      selectedSchedule: value.selectedSchedule,
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, isSubmitted } = this.state;
    if (!schema) return <Progress />;

    // if (isSubmitted) {
    //   dialog.fire({
    //     html: (
    //       <div
    //         className="d-flex gap-3 flex-column align-items-center justify-content-center p-5"
    //         // style={{ height: "100vh" }}
    //       >
    //         <Spin size="large" />
    //         <p>Loading...</p>
    //       </div>
    //     ),
    //     footer: false,
    //   });
    // }

    return (
      <>
        <div style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4 h-auto">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} System Administration {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    Manual Timesheets
                  </span>
                </p>
              </div>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.presenter.handleSubmitBtn();
                }}
              >
                <div className="w-100 mt-2 d-flex gap-2">
                  <SearchSelect
                    value={this.state.employee?.name}
                    focus={true}
                    required={true}
                    onClickClear={() => this.handleChange({ name: "" })}
                    onChange={(value) => this.handleChange(value)}
                    options={this.state.employees.map((emp) => {
                      const { Firstname, Middlename, surname, ...rest } = emp;
                      const empName = `${surname || ""}, ${Firstname || ""} ${
                        Middlename || ""
                      }`;
                      return {
                        label: empName,
                        value: {
                          name: empName,
                          ...rest,
                        },
                      };
                    })}
                  />
                  <div>
                    <input
                      type="file"
                      ref={this.fileInputRef}
                      disabled={!this.state.employee.id}
                      accept=".xlsx, .xls"
                      className="form-control"
                      onChange={(e) => this.presenter.handleExcelUpload(e)}
                      required={true}
                    />
                  </div>
                  <Button type="submit">Import</Button>
                </div>
              </form>

              {/* migrate test  */}
              {/* <h5 className="mt-5 mb-5">Migrate Biometric Files</h5>
              <form
                className="d-flex gap-2"
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <div>
                  <input
                    type="file"
                    accept=".dat"
                    className="form-control"
                    onChange={(event) => {
                      this.presenter.fileReader(event);
                    }}
                    required={true}
                  />
                </div>
                <Button type="submit">Import</Button>
              </form> */}
            </div>
          </InfiniteScroll>
        </div>
        {isSubmitted && (
          <FloatingForm width={"30rem"}>
            <CardView>
              <div
                className="d-flex gap-3 flex-column align-items-center justify-content-center p-5"
                // style={{ height: "100vh" }}
              >
                <Spin size="large" />
                <p>Loading...</p>
              </div>
            </CardView>
          </FloatingForm>
        )}
      </>
    );
  }
}

export default withRouter(ManualTSheetsPage);
